export default __webpack_public_path__ + "static/media/aave.d8c491f3.svg";